export default __webpack_public_path__ + "static/media/apple-icon.348e84b8.svg";